<template>
  <div id="app" class="teal darken-4">
    <notification></notification>
    <router-view />
  </div>
</template>

<script>
import Notification from '@/components/layout/Notification';

export default {
  components: { Notification }
};
</script>
